import {
	UPDATE_WAITING_TIME_SCHEDULE,
	SET_WAITING_TIME_SCHEDULE,
	RESET_WAITING_TIME_SCHEDULE,
	EDIT_BATCH_LIST_ITEM,
	REMOVE_BATCH_LIST_ITEM,
	ADD_BATCH_LIST_ITEM_ROW,
} from './waitingTimeSchedules.actions';

// utils
import _uniqueId from 'lodash/uniqueId';

const defaultState = {
	data: {
		defaultWaitingTimeSchedule: {},
		batchList: [
			{
				identifier: _uniqueId('row-'),
				name: '',
				description: '',
			},
		],
	},
};

function reducer(state = defaultState, action) {
	const { type, payload } = action;

	switch (type) {
		case SET_WAITING_TIME_SCHEDULE: {
			return {
				data: {
					defaultWaitingTimeSchedule: payload,
				},
			};
		}

		case UPDATE_WAITING_TIME_SCHEDULE: {
			return {
				data: {
					defaultWaitingTimeSchedule: {
						...state.data.defaultWaitingTimeSchedule,
						...payload,
					},
				},
			};
		}

		case RESET_WAITING_TIME_SCHEDULE: {
			return {
				...defaultState,
			};
		}

		case EDIT_BATCH_LIST_ITEM: {
			return {
				...state,
				data: {
					...state.data,
					batchList: state.data.batchList.map((entry) => {
						if (entry.identifier === payload.identifier) return payload;
						return entry;
					}),
				},
			};
		}

		case REMOVE_BATCH_LIST_ITEM: {
			return {
				...state,
				data: {
					...state.data,
					batchList: state.data.batchList.filter(
						(entry) => entry.identifier !== payload
					),
				},
			};
		}

		case ADD_BATCH_LIST_ITEM_ROW: {
			return {
				...state,
				data: {
					...state.data,
					batchList: [
						...state.data.batchList,
						{
							...defaultState.data.batchList[0],
							identifier: _uniqueId('row-'),
						},
					],
				},
			};
		}

		default:
			return state;
	}
}

export default reducer;
